import styled from 'styled-components';

export const Divider = styled('div')`
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  margin: 16px 0;
`;

export const Title = styled('h2')`
  font-size: 19px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 16px;
`;
